import { render, staticRenderFns } from "./RouteItineraries.vue?vue&type=template&id=3a8c448b"
import script from "./RouteItineraries.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteItineraries.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports